import "core-js/modules/es6.function.name";
import u, { useContext as d, useRef as y, useEffect as C } from "react";
import { PrimaryNavContext as I } from "./PrimaryNavContext";
import _ from "clsx";
import { Flyout as N } from "./Flyout";
import { SubmenuTriggerButton as x } from "./SubmenuTriggerButton";

var F = function F(_ref) {
  var e = _ref.item,
      v = _ref.isActive;

  var _d = d(I),
      r = _d.activeFlyout,
      m = _d.handleFlyoutOpen,
      o = _d.handleFlyoutClose,
      t = _d.setActiveFlyout,
      a = _d.setIsAnimating,
      p = _d.isSubmenuOpen,
      g = _d.setIsSubmenuOpen,
      i = _d.isBreakpointWithMenu,
      l = _d.isTouch,
      c = _d.isAnimating,
      h = _d.setIsDesktopMenuOpen,
      n = y(null),
      s = y(null),
      f = function f(T) {
    e.submenu && (i || l) && (T.preventDefault(), r === n.current ? (t(null), a(!0), o()) : (a(!0), t(n.current), m()));
  },
      b = function b() {
    r !== n.current ? (a(!0), g(!0), t(n.current), m()) : (a(!0), t(null), o());
  },
      M = function M() {
    e.submenu && !i && !l && (t(n.current), h(!1), s.current = setTimeout(function () {
      m();
    }, 240));
  },
      k = function k() {
    e.submenu && !i && !l && (s.current && clearTimeout(s.current), t(null), o());
  };

  return C(function () {
    return function () {
      s.current && clearTimeout(s.current);
    };
  }, []), u.createElement("div", {
    ref: n,
    className: _("hg-primarynav__item", "hg-primarynav__item--".concat(e.name.toLowerCase()), "hg-primarynav__item--menu", {
      "hg-primarynav__item-submenu": e.submenu,
      "hg-primarynav__hide--desktop": e.hideOnPrimaryDesktop,
      "hg-primarynav__item--flyout-open": !i && r && r === n.current || i && p && !c && r && r === n.current,
      "hg-primarynav__item--flyout-next": i && c && r === n.current
    }),
    style: {
      "--primarynav-flyout-item-number": 0
    },
    onMouseEnter: M,
    onMouseLeave: k
  }, u.createElement("ul", {
    className: "hg-primarynav__submenu-trigger-group"
  }, u.createElement("li", {
    className: "hg-primarynav__submenu-trigger-item"
  }, u.createElement("a", {
    href: e.url,
    className: _("hg-primarynav__link", "hg-primarynav__submenu-trigger-link", "hg-primarynav__link--".concat(e.name.toLowerCase()), {
      "hg-primarynav__link--active": v
    }),
    onClick: f
  }, u.createElement("span", {
    className: "hg-primarynav__link-text-container"
  }, e.label))), e.submenu && u.createElement("li", {
    className: "hg-primarynav__submenu-trigger-item"
  }, u.createElement(x, {
    item: e,
    onClick: b,
    isOpen: p && r === n.current
  }))), e.submenu && u.createElement(N, {
    submenu: e.submenu
  }));
};

export { F as MenuItem };